export default "__VITE_ASSET__0a27cdf4__"